import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import { Dropdown, List, Card, Modal, Label, Button, Popup, Image, Loader, PlaceholderLine, Message } from 'semantic-ui-react';
import NothingToShow from "../../../../drive/NothingToShow";
import PlaceHolderSingleLine from '../../../../drive/PlaceHolder/PlaceHolderSingleLine';
import localImage from '../../../../../images/logo/logo-128.png'
import AddNewIntegrationModal from '../Modal/AddNewIntegration';
import { toastr } from 'react-redux-toastr';


class IntegrationList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIntegration: null,
            integrations: [{
                image: localImage,
                name: "Jira",
                description: "Jirs application is task manager",
                version: "1.2.5"
            },
            {
                image: localImage,
                name: "Sales Force",
                description: "cloud setup information",
                version: "1.6.3"
            }]
        }
    }
    setSelectedIntegration = (data) => {
        this.setState({ selectedIntegration: data })
    }
    async componentDidMount() {

      await dispatch.integrations.getIntegrations()

    }

    render() {
        const { newIntegrationFlag } = this.props
        // const { integrations } = this.state
        const { integrationsList } = this.props

        let NoData = <NothingToShow imgStyle={{ display: "block" }} />
        let CardList = integrationsList ?
            integrationsList && integrationsList.data.length !== 0 ?
                <List divided verticalAlign='middle'>
                    {integrationsList && integrationsList.data.map((intItem, index) => {
                        return <List.Item
                            className={`singleLine categoryList `}
                            key={index}
                        >
                            <List.Content floated='right'
                                className="listViewWithAction"
                            >
                                <ActionIcons
                                    intItem={intItem}
                                    setSelectedIntegration={this.setSelectedIntegration} />
                            </List.Content>
                            <List.Content>
                                <List.Header >
                                    <Name intItem={intItem} />
                                </List.Header>
                            </List.Content>
                        </List.Item>
                    })
                    }
                </List > : NoData :
            <PlaceHolderSingleLine repeat={5} />

        let AddIntegrationModal = <AddNewIntegrationModal
            newIntegrationOpen={this.props.newIntegrationFlag}
            envData={this.props.envData}
            selectedIntegration={this.state.selectedIntegration}
            setSelectedIntegration={this.setSelectedIntegration}
            integrationsList={this.props.integrationsList} 
            integrationModalType={this.props.integrationModalType}/>
            

        return (
            <div className="general-setting">

                <Card>
                    <Card.Header>
                        Integration &nbsp;<Label size="mini" > {integrationsList && integrationsList.data.length}</Label>
                    </Card.Header>
                    <Card.Content className="pad_0">
                        {CardList}
                        {AddIntegrationModal}
                    </Card.Content>
                </Card>

            </div>
        );
    }
}

class Name extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        const { intItem } = this.props
        return <span>
            <Image avatar src={intItem.image} className="w_24 h_24" />
            {intItem.label} &nbsp;
        </span>
    }
}

class ActionIcons extends Component {

    constructor(props) {
        super(props)
        this.state = {

        }
    }

    iconClick = (e, data, actions) => {
        if (actions.name === "Edit") {
            dispatch.platform.setIntegrationModal(true)
            dispatch.platform.setIntegrationModalType("edit")
            this.props.setSelectedIntegration(data)
        }

        if (actions.name === "Delete") {
            let message = <div className="confirmMessage">
            <h3>Remove Integration</h3> 
            <label>{data.label}</label>
            <p>Are you sure, you want to delete?</p>
            </div>
            toastr.confirm(message, {
                onOk: async () => {
                  await dispatch.integrations.deleteIntegrations(data);
                  toastr.success("Integration", "Integration deleted successfully.");

                }
              });
            //this.openTextModal(e, true, data)
        }
    }

    render() {
        const { intItem } = this.props

        let actions = [{
            name: "Edit",
            icon: "pencil",
            disabled: false,
            display: true
        }, 
        // {
        //     name: "Delete",
        //     icon: "trash alternate",
        //     disabled: false,
        //     display: true
        // }
    ]

        let ActionItems = <Dropdown icon='ellipsis vertical' pointing="right">
            <Dropdown.Menu>
                {actions && actions.map((item, ind) => {
                    return <Dropdown.Item
                        key={item.name}
                        onClick={(e) => this.iconClick(e, intItem, item)}
                        text={item.name}
                        icon={item.icon}
                        disabled={false} />
                })}
            </Dropdown.Menu>
        </Dropdown>


        return <React.Fragment>
            {ActionItems}
        </React.Fragment>
    }
}


// function mapStateToProps(state) {
//     return {
//         integrationsList:state.integrations.integrationsList
//   };
// }
// export default connect(mapStateToProps)(IntegrationList)
export default IntegrationList;